// import React, { useEffect, useState } from "react";
// import GaugeChart from "react-gauge-chart";

// const parseDMY = (d) => {
//   const [day, month, year] = d.split("-").map(Number);
//   return new Date(year, month - 1, day);
// };

// const AnimatedGauge = ({ value, label, id }) => {
//   const [percent, setPercent] = useState(0);
//   const [display, setDisplay] = useState(0);

//   useEffect(() => {
//     const targetPercent = value / 100;
//     const duration = 1000;
//     let startTime = null;

//     const animate = (timestamp) => {
//       if (!startTime) startTime = timestamp;
//       const progress = Math.min((timestamp - startTime) / duration, 1);
//       setPercent(progress * targetPercent);
//       setDisplay(progress * value);
//       if (progress < 1) requestAnimationFrame(animate);
//     };
//     requestAnimationFrame(animate);
//   }, [value]);

//   return (
//     <div className="text-center flex-grow-1">
//       <GaugeChart
//         id={id}
//         nrOfLevels={30}
//         arcWidth={0.3}
//         colors={["#EA4228", "#F5CD19", "#5BE12C"]}
//         percent={percent}
//         textColor="black"
//         className="my-2"
//       />
//       <h6 className="steelblue mb-0">
//         {label}: {display.toFixed(1)}
//       </h6>
//     </div>
//   );
// };

// const FarmerGaugeChart2 = ({ farmerDataCl, chartName }) => {
//   const scores={
//     "ACS": [
//         {
//             "09-07-2025": 55.49
//         },
//         {
//             "04-07-2025": 50.49
//         }
//     ],
//     "crop_health": [
//         {
//             "09-07-2025": 0.75
//         },
//         {
//             "09-07-2025": 0.75
//         }
//     ]
// }
//   console.log("scores",scores)
//   const scoreOptions =
//     scores?.ACS?.flatMap((entry) =>
//       Object.entries(entry).map(([date, value]) => ({
//         date,
//         value: Number(value),
//       }))
//     ) ?? [];

//   let gauges = [];
//   if (scoreOptions.length) {
//     const sorted = [...scoreOptions].sort(
//       (a, b) => parseDMY(a.date) - parseDMY(b.date)
//     );
//     const historical = sorted[0];
//     const current = sorted[sorted.length - 1];

//     gauges =
//       historical.date === current.date
//         ? [{ ...current, label: "Current" }]
//         : [
//             { ...historical, label: "Historical" },
//             { ...current, label: "Current" },
//           ];
//   } else if (farmerDataCl !== undefined) {
//     gauges = [{ value: farmerDataCl, label: chartName ?? "Value" }];
//   }
//   console.log("gauges",gauges)
//   return (
//     <React.Fragment>
//       <div className="d-flex justify-content-center gap-4 flex-wrap">
//         {gauges.map((g, idx) => (
//           <AnimatedGauge
//             key={g.label}
//             value={g.value}
//             label={g.label}
//             id={`gauge-${idx}`}
//           />
//         ))}
//       </div>

//       <div className="text-center my-2">
//         <div
//           className="d-flex justify-content-between align-items-center bg-white rounded px-2"
//           style={{ fontSize: "0.75rem" }}
//         >
//           <div className="d-flex align-items-center me-1" title="ACS < 50: Poor">
//             <i className="mdi mdi-circle text-danger me-1" style={{ fontSize: "0.65rem" }}></i>
//             <span className="text-muted me-1">&lt; 50:</span>
//             <strong className="text-danger">Poor</strong>
//           </div>
//           <div className="d-flex align-items-center mx-1" title="ACS 50–60: Normal">
//             <i className="mdi mdi-circle me-1" style={{ color: "#ffc107", fontSize: "0.65rem" }}></i>
//             <span className="text-muted me-1">50–60:</span>
//             <strong style={{ color: "#ffc107" }}>Normal</strong>
//           </div>
//           <div className="d-flex align-items-center ms-1" title="ACS > 60: Good">
//             <i className="mdi mdi-circle text-success me-1" style={{ fontSize: "0.65rem" }}></i>
//             <span className="text-muted me-1">&gt; 60:</span>
//             <strong className="text-success">Good</strong>
//           </div>
//         </div>
//       </div>
//     </React.Fragment>
//   );
// };

// export default FarmerGaugeChart2;




import React, { useState, useEffect } from "react";
import GaugeChart from "react-gauge-chart";

const FarmerReportGaugeChart2 = ({ farmerDataCl,chartName  }) => {
  const [animatedPercent, setAnimatedPercent] = useState(0);
  const [animatedValue, setAnimatedValue] = useState(0);

  useEffect(() => {
    if (!farmerDataCl) return;
    const targetPercent = farmerDataCl / 100;
    const targetValue = farmerDataCl;
    let startTime = null;
    const duration = 1000;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setAnimatedPercent(progress * targetPercent);
      setAnimatedValue(progress * targetValue);
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [farmerDataCl]);

  return (
    <React.Fragment>
      <GaugeChart
        id="gauge-chart3"
        nrOfLevels={30}
        colors={["#EA4228", "#F5CD19", "#5BE12C"]}
        arcWidth={0.3}
        percent={farmerDataCl ? animatedPercent : 0}
        textColor={"black"}
        className="my-3"
      />
      <h5 className="text-center steelblue">
        {chartName} : {farmerDataCl ? animatedValue.toFixed(1) : "-"}
      </h5>
      <div className="text-center my-2">
        <div
          className="d-flex justify-content-between align-items-center bg-white rounded px-2"
          style={{ fontSize: "0.75rem" }}
        >
          <div
            className="d-flex align-items-center me-1"
            title="ACS < 50: Poor"
          >
            <i
              className="mdi mdi-circle text-danger me-1"
              style={{ fontSize: "0.65rem" }}
            ></i>
            <span className="text-muted me-1">&lt; 50:</span>
            <strong className="text-danger">Poor</strong>
          </div>

          <div
            className="d-flex align-items-center mx-1"
            title="ACS 50–60: Normal"
          >
            <i
              className="mdi mdi-circle me-1"
              style={{ color: "#ffc107", fontSize: "0.65rem" }}
            ></i>
            <span className="text-muted me-1">50–60:</span>
            <strong style={{ color: "#ffc107" }}>Normal</strong>
          </div>

          <div
            className="d-flex align-items-center ms-1"
            title="ACS > 60: Good"
          >
            <i
              className="mdi mdi-circle text-success me-1"
              style={{ fontSize: "0.65rem" }}
            ></i>
            <span className="text-muted me-1">&gt; 60:</span>
            <strong className="text-success">Good</strong>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FarmerReportGaugeChart2;
